<template>
  <section v-if="componentReady" class="model-page">
    <div class="container-wrapper ">
      <div class="model-page__top">
        <h1 class="model-page__title">{{ title }}</h1>

        <VinChecker @errText="setVinError" />
      </div>

      <CollapseTransition>
        <div v-if="vinError" key="errWrapper">
          <NotificationBanner
            :msg="vinError"
            :background="vinBackground"
            class="model-page__error"
          />
        </div>
      </CollapseTransition>

      <div class="model-page__models">
        <Cars
          :cars="models"
          @select="onModelSelected"
        />
      </div>
    </div>
  </section>
</template>

<script>
  // Step 1

  import { get } from 'lodash'
  import { mapActions } from 'vuex'

  import { CollapseTransition } from 'vue2-transitions'

  import VinChecker from '@/components/VinChecker'
  import Cars from '@/components/Cars/Cars'
  import NotificationBanner from '@/components/NotificationBanner'
  import { DEFAULT_LANG } from '@/helpers/constant'

  export default {
    name: 'ModelPage',

    components: {
      VinChecker,
      Cars,
      NotificationBanner,
      CollapseTransition
    },

    data () {
      return {
        title: '',
        models: [],
        componentReady: false,
        firstTime: true,
        vinError: '',
        vinBackground: ''
      }
    },

    computed: {},

    watch: {
      $route (to) {
        if (this.vinError && to.name !== 'model') {
          this.vinError = ''
        }
      }
    },

    async created () {
      const data = await this.fetchModelPageData()
      this._data = Object.assign(this._data, data)

      this.componentReady = true

      this.loadDataLayer()
    },

    methods: {
      ...mapActions(['fetchModelPageData']),
      onModelSelected: function (model) {
        let query = {}
        if (this.$store.state.currentLang !== DEFAULT_LANG) {
          query = { lang: this.$store.state.currentLang }
        }

        this.$router.push({
          name: 'modification',
          params: { model },
          query: query
        })
      },
      setVinError ({ text, color }) {
        this.vinError = text
        this.vinBackground = color
      },

      loadDataLayer () {
        window.tngaDataLayer = window.tngaDataLayer || {}

        const page = {
          category: 'tools',
          subCategory: 'form',
          sectionlv1: 'forms',
          sectionlv2: 'book-service',
          language: this.$store.state.currentLang
        }

        const form = {
          name: 'lead-book-service',
          step: 'select-model',
          conversion: '0'
        }

        window.tngaDataLayer = { page, form }

        this.$store.commit('setGeneralData')
      }
    }
  }
</script>

<style lang="scss">
  .model-page {
    &__top {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      @include tablet {
        flex-direction: column;
        align-items: flex-start;
      }
    }

    &__title {
      max-width: 437px;
      font-size: 40px;
      line-height: 1.4;
      letter-spacing: 0.08px;

      @include tablet {
        max-width: 100%;
        margin: {
          bottom: 30px;
        };
      }

      @include mobile {
        font-size: 28px;
        line-height: 40px;
      }
    }

    &__models {
      margin-top: 60px;

      @include mobile {
        margin-top: 40px;
      }
    }
  }
</style>
